import { ClearFilledIcon } from 'components/icons/ClearFilledIcon'
import React from 'react'
import './index.css'

const PanelComponent: React.FC<{
  title?: string
  onCancel: () => void
  className?: string
  children: React.ReactNode
}> = ({ title, onCancel, className, children }) => {
  return (
    // This is the main container with the signature yellow left border
    <div
      className={`border p-4 my-2 rounded-xl w-full transition-colors border-custom-yellow border-l-8 shadow-lg bg-white ${className} relative`}
    >
      {/* Clear button in top-right corner */}
      {onCancel && (
        <button onClick={onCancel} className='absolute top-2 right-2 p-2' aria-label='Close panel'>
          <ClearFilledIcon />
        </button>
      )}
      {/* 1. Unified Header */}
      {title && (
        <div className='flex items-center justify-between pb-3 mb-3 border-b border-gray-200'>
          <p className='text-sm font-semibold text-gray-800'>
            <span className='inline-block py-1 px-3 rounded-full'>{title}</span>
          </p>
        </div>
      )}

      {/* 2. The children (Preview and Bulk Update) will be rendered here */}
      <div className='space-y-4'>{children}</div>
    </div>
  )
}

export default PanelComponent
